import React from 'react'
import PlaceholderImage from 'components/PlaceholderImage'
import ReceiptViewHeader from './ReceiptViewHeader'
import ReceiptStatus from './ReceiptStatus'
import ShareIcons from 'components/ShareIcons'

import './ThankYouView.scss'

const ThankYouView = ({
  step,
  headline,
  bodyCopy,
  image,
  handleShareClick,
}) => {
  const imageUrl =
    image && image.id ? `${process.env.SITE_ASSET_URL}/${image.id}` : null
  const alt = image && image.alt ? image.alt : ''

  let showSocial = step.socialShareOn ? step.socialShareOn : true
  const socialShareComponent = showSocial && (
    <ShareIcons
      facebookShare={step.facebookShare}
      twitterShare={step.twitterShare}
      pinterestShare={step.pinterestShare}
      emailShare={step.emailShare}
      emailConfig={{
        subject: step.shareEmailSubject,
        body: step.shareEmailBody,
      }}
      copyShare={step.copyShare}
      whatsappShare={step.whatsappShare}
      shareUrl={step.shareUrl}
      onShareClick={handleShareClick}
    />
  )
  return (
    <div className={`receipt-view thank-you-view`}>
      <ReceiptViewHeader headline={headline} introCopy={bodyCopy} />
      {imageUrl && (
        <div className={`receipt-view-header-image`}>
          <PlaceholderImage
            src={imageUrl}
            width={1490}
            height={624}
            className={''}
            alt={alt}
          />
        </div>
      )}
      {socialShareComponent}
    </div>
  )
}
export default ThankYouView
